module.exports = __webpack_public_path__ + "img/footprint.c23e0c43.png";